import { Button, TextField } from "@mui/material";
import { AnimatePresence, motion } from "motion/react";
import { useState } from "react";
import LoadingSpinner from '../Spinner';
import { Flip, ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { toast_config } from "./toastify/config";
import apiCumbres from "../axios/axios";
import Swal from "sweetalert2";
import { useSelector } from 'react-redux';
import { styleBtn, textFieldStyle } from "./Styles";

const RegistrarCliente = () => {
    const [isLoading, setIsLoading] = useState(false)
    const tkn = useSelector((state) => state.tknAuth)

    const fields = [
        { label: "Nombre Cliente", cols: 4, key: 'nombre', initial: { opacity: 0, x: -50 }, animate: { opacity: 1, x: 0 } },
        { label: "Apellido Paterno Cliente", cols: 4, key: 'paterno', initial: { opacity: 0, y: -90 }, animate: { opacity: 1, y: 0 } },
        { label: "Apellido Materno Cliente", cols: 4, key: 'materno', initial: { opacity: 0, x: 50 }, animate: { opacity: 1, x: 0 } },
        { label: "Dirección", cols: 10, key: 'direccion', initial: { opacity: 0, x: -50 }, animate: { opacity: 1, x: 0 } },
        { label: "Telefono", cols: 5, key: 'telefono', initial: { opacity: 0, x: -50 }, animate: { opacity: 1, x: 0 } },
        { label: "Correo", cols: 5, key: 'correo', initial: { opacity: 0, x: 50 }, animate: { opacity: 1, x: 0 } },
        { label: "Notas", cols: 5, multiline: true, rows: 2, key: 'notas', initial: { opacity: 0, x: -50 }, animate: { opacity: 1, x: 0 } },
    ];

    const formatPhone = (value) => {
        // Elimina todo lo que no sea número
        const digits = value.replace(/\D/g, '');
        // Aplica formato (XXX) XXX-XXXX
        const match = digits.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);
        if (!match) return '';
        return [
            match[1] ? `(${match[1]}` : '',
            match[2] ? `) ${match[2]}` : '',
            match[3] ? `-${match[3]}` : ''
        ].join('');
    };

    const [formData, setFormData] = useState({
        nombre: "",
        paterno: "",
        materno: "",
        direccion: "",
        telefono: "",
        correo: "",
        notas: "",
        usuarioIdRegistro: ""
    });

    const handleChange = (field) => (e) => {
        let value = e.target.value.toUpperCase(); // Convertir a mayúsculas
        if (field === "telefono") {
            value = formatPhone(value); // Formato de teléfono
        }
        setFormData({ ...formData, [field]: value });
    };

    const registrarCliente = () => {

        Swal.fire({
            title: "Esta seguro?",
            text: `Se registrara cliente con la información seleccionada!`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Si, registrar!"
        }).then((result) => {

            if (!result.isConfirmed) return

            // Validar que todos los campos tengan valor
            const emptyField = fields.find(f => f.key !== "apellidoMaterno" && !formData[f.key]?.trim());
            if (emptyField) {
                toast.error(`El campo "${emptyField.label}" es obligatorio.`, toast_config)
                return;
            }

            const registrar = async () => {

                try {
                    setIsLoading(true)
                    formData.usuarioIdRegistro = tkn.usuarioId
                    const crear = await apiCumbres.post('/clientes/crear', formData, {
                        headers: {
                            'Accept': 'application/x-www-form-urlencoded',
                            'Content-Type': 'application/x-www-form-urlencoded',
                        }
                    })

                    setIsLoading(false)

                    Swal.fire({
                        icon: 'success',
                        title: 'Enhorabuena!',
                        text: crear.data.mensaje
                    }).then((result) => {
                        window.location.href = '/clientes'
                    })


                } catch (error) {
                    let msg_error = ''
                    if (error.response) {
                        console.log(error.response)
                        if (error.response.data.error) {
                            msg_error = error.response.data.error
                        } else {
                            msg_error = 'Ocurrió un error al registrar cliente, favor de volver a intentarlo!'
                        }
                    } else {
                        console.log(error)
                        msg_error = 'No hay respuesta por parte del servidor!'
                    }
                    //mensaje de toastify
                    setIsLoading(false)
                    toast.error(msg_error, toast_config)
                }

            }

            registrar()

        })




    }

    return (
        <>


            <motion.div layout className="container mb-5" >
                {isLoading ?
                    <LoadingSpinner />
                    : null}
                <motion.div layout className="row">
                    <div className="col-md-12">
                        <AnimatePresence>
                            <motion.div
                                layout
                                key="form-card"
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                exit={{ opacity: 0, y: -30 }}   // ⬅️ efecto de salida de la tarjeta completa
                                transition={{ duration: 0.4, ease: "easeInOut" }}
                            >
                                <div
                                    className="card shadow-lg  p-5 border-0"
                                    style={{ borderRadius: '20px' }}
                                >
                                    <div className="row">
                                        <motion.h1 className="color-primary"
                                            initial={{ opacity: 0, y: -90 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            exit={{ opacity: 0, y: -20 }}
                                            transition={{ duration: 0.5, ease: "easeOut", delay: 0.3 }}>
                                            Registrar Clientes
                                        </motion.h1>
                                        <hr className="mb-5" />
                                        {/* Campos animados */}
                                        {fields.map((field, index) => (
                                            <motion.div
                                                key={index}
                                                className={`col-md-${field.cols} mb-3`}
                                                initial={field.initial}
                                                animate={field.animate}
                                                transition={{ duration: 0.5, ease: "easeOut", delay: 0.15 * index }}
                                            >
                                                <TextField
                                                    variant="outlined"
                                                    fullWidth
                                                    label={field.label}
                                                    multiline={field.multiline || false}
                                                    rows={field.rows || 1}
                                                    sx={textFieldStyle}
                                                    value={formData[field.key]}
                                                    onChange={handleChange(field.key)}
                                                />
                                            </motion.div>
                                        ))}

                                        <motion.div
                                            className="col-md-12 mt-3"
                                            initial={{ opacity: 0, y: 50 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            exit={{ opacity: 0, y: 30 }}
                                            transition={{ duration: 0.5, ease: "easeOut", delay: 0.9 }}
                                            whileHover={{
                                                y: -4,
                                                scale: 1.03,
                                                filter: "brightness(1.1)",
                                                transition: { duration: 0.25, ease: "easeOut" },
                                            }}
                                        >
                                            <Button variant="contained" fullWidth sx={styleBtn} onClick={registrarCliente}>
                                                Registrar
                                            </Button>
                                        </motion.div>
                                    </div>
                                </div>
                            </motion.div>
                        </AnimatePresence>
                    </div>
                </motion.div>
                <ToastContainer
                    transition={Flip}
                    position="bottom-center"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="colored" />
            </motion.div>

        </>


    )

}

export default RegistrarCliente